import { useState } from 'react';

const ReportInfoBlock = ({
  agentName,
  dateLabel,
  dateValue,
  goalLabel,
  goalValue,
  onGoalChange,
  areasWorked,
  onAreasWorkedChange,
  managerName = "Fred Hawkins",
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 min-w-[240px] flex-shrink-0" data-testid="report-info-block">
      <div className="space-y-2">
        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Name</label>
          <p className="font-semibold text-gray-900 text-sm" data-testid="info-agent-name">{agentName}</p>
        </div>
        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">{dateLabel}</label>
          <p className="font-semibold text-gray-900 text-sm" data-testid="info-date-value">{dateValue}</p>
        </div>
        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">{goalLabel}</label>
          <input
            type="text"
            value={goalValue}
            onChange={(e) => onGoalChange(e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-brand-blue focus:outline-none"
            placeholder="Enter goal..."
            data-testid="info-ap-goal"
          />
        </div>
        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Manager / Field Trainer</label>
          <p className="font-semibold text-gray-900 text-sm" data-testid="info-manager">{managerName}</p>
        </div>
        <div>
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Areas Worked</label>
          <input
            type="text"
            value={areasWorked}
            onChange={(e) => onAreasWorkedChange(e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-brand-blue focus:outline-none"
            placeholder="Enter areas..."
            data-testid="info-areas-worked"
          />
        </div>
      </div>
    </div>
  );
};

export default ReportInfoBlock;
